module.exports = __webpack_public_path__ + "static/img/fascia_detail.12351aa1.png";